import React from 'react';

const AboutHero: React.FC = () => (
  <section className="bg-white min-h-screen flex items-center justify-center">
    <div className="container-main text-center w-full">
      <h1 className="text-5xl md:text-7xl font-light text-gray-900 tracking-tight mt-20 md:mt-0">About us</h1>
    </div>
  </section>
);

export default AboutHero;
